class TMv_EmployeeList extends TCv_SearchableModelList
{
	selected_department_id = null;
	department_container = null;

	constructor(element, values = {}) {
		super(element, values);

		// Add the target component
		this.department_container = document.createElement('div');
		this.department_container.setAttribute('id','department_container');
		this.element.querySelector('.list_container').prepend(this.department_container);

		// Trigger at the start
		this.departmentChanged();
	}

	/**
	 * Extend the clear filter function to also detect the department changed
	 * @param event
	 */
	clearFilters(event) {
		super.clearFilters(event);
		this.departmentChanged();
	}

	/**
	 * Extend to deal with department change
	 */
	cleanUpAppliedFilters() {
		super.cleanUpAppliedFilters();
		this.departmentChanged();
	}

	/**
	 * Extend the select field handler to detect if the department changes and show that department's data.
	 * @param event
	 */
	selectFieldChanged(event) {

		// Detect if we're dealing with the department, trigger the change
		if(event.target.id === 'department_id')
		{
			this.departmentChanged();
		}

		super.selectFieldChanged(event);
	}

	departmentChanged() {

		let department_id = this.element.querySelector('#department_id')?.value;
		// Selected department ID changed
		if(this.selected_department_id != department_id)
		{
			this.selected_department_id = department_id;

			if(this.selected_department_id > 0)
			{

				fetch('/admin/employees/do/department-attributes/' + this.selected_department_id, {
					method : 'GET',
				}).then(response => response.json())
					.then(response =>
					{
						// // UPDATE CSS:  the list css if it's set
						processAsyncCSSLinks(response.css);

						// Update the container
						this.department_container.innerHTML = response.html;

					});

			}
			else // no department selected
			{
				// Remove any attributes if they exist
				if(this.department_container)
				{
					this.department_container.innerHTML = '';
				}
			}
		}
	}

}